import React from "react";
import ExploreCard from "./ExploreCard";
import ExploreSidebar from "./ExploreSidebar";

const Explore = () => {
    const exploreCardItem = [ 1,2,3,4,5,6,7,8,9,10,11,12];
    return (
        <>
            <div className="_nft_expnew_wrapper">
                <div className="_nft_expnew_wrap">
                    <div className="_nft_expnew_container">
                        <ExploreSidebar/>
                        <div className="_nft_expnew_main_wrap">
                            <div className="_nft_expnew_main_inner">
                                <div className="row">
                                    {
                                        exploreCardItem.map((item,id)=>
                                            <ExploreCard/>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default Explore;